<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "customer"
  }
</script>

<style scoped>

</style>
